export class ProfileMessages {
  public static readonly EDIT_PROFILE = 'profile.edit-profile';
  public static readonly RESTRICTED_TITLE = 'profile.restricted.title';
  public static readonly RESTRICTED_BODY = 'profile.restricted.body';
}
